export default "__VITE_PUBLIC_ASSET__97041ccd__"